<template>
  <main id="loginpage">
		<div class="container-fluid">
			<div class="row align-items-center">
				<div class="col-md-6 col-lg-7 fullscreen-md d-flex
          justify-content-center align-items-center overlay gradient
          gradient-53 alpha-7 image-background cover"
          style="background-image:url(https://picsum.photos/1920/1200/?random&gravity=south)">
					<div class="content">
						<h2 class="display-4 display-md-3 color-1 mt-4 mt-md-0 px-0">
              Welcome to
							<span class="bold d-block">PCMonde</span>
						</h2>
						<p class="lead color-1 alpha-5">Login to your account</p>
					</div>
				</div>
				<div class="col-md-5 col-lg-4 mx-auto">
					<div class="login-form mt-5 mt-md-0">

						<h1 class="color-5 bold">Login</h1>
						<form class="cozy">
							<label class="control-label bold small text-uppercase color-2">
                Username
              </label>
							<div class="form-group has-icon">
								<input v-model="username"
                  type="text" class="form-control form-control-rounded"
                  placeholder="Your registered email"
                  required>
								<i class="icon fas fa-user"></i>
							</div>
							<label class="control-label bold small text-uppercase color-2">
                Password
              </label>
							<div class="form-group has-icon">
								<input
                  v-model="password"
                  type="password"
                  class="form-control form-control-rounded"
                  placeholder="Your password" required>
								<i class="icon fas fa-lock"></i>
							</div>
							<div class="form-group d-flex align-items-center justify-content-between">
								<div class="ajax-button">
									<div class="fas fa-check btn-status text-success success"></div>
									<div class="fas fa-times btn-status text-danger failed"></div>
									<button
                    v-on:click.prevent="login"
                    class="btn btn-accent btn-rounded">
                    Login
										<i class="fas fa-long-arrow-alt-right ml-2"></i>
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
export default {
	name: 'loginpage',
	props: {
		loggedin: Boolean,
	},
	data() {
		return {
			username: this.value,
			password: this.value,
		};
	},
	methods: {
		login: function() {
			this.$Progress.start();
			this.$axios
				.post('/login', {
					username: this.username,
					password: this.password
				})
				.then((response) => {
					this.$cookies.set('user_session', response.data.access_token);
					this.$root.$emit('is_loggedin', true);
					this.$router.push({path: '/items/data'});
				})
				.catch((error) => {
					alert('Wrong username / password.');
					console.log(error);
				})
				.finally(()=>{
					this.$Progress.finish();
				});
		},
	},
};
</script>
